import { Moment } from "moment";

interface Fields {
  cmr_date?: Moment;
  loading_date?: Moment;
  arrival_for_loading?: Moment;
  departure?: Moment;
}

const getValue = (
  date: Moment | null | undefined,
  format = "YYYY-MM-DD"
): string | null => {
  if (date && date.isValid()) {
    return date.format(format);
  }

  return null;
};

const normalize = (fields: Fields): Object => ({
  ...fields,
  cmr_date: getValue(fields.cmr_date),
  loading_date: getValue(fields.loading_date),
  arrival_for_loading: getValue(
    fields.arrival_for_loading,
    "YYYY-MM-DD HH:mm:ss"
  ),
  departure: getValue(fields.departure, "YYYY-MM-DD HH:mm:ss"),
});

export default normalize;
